import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Navigation, Phone, Clock } from "lucide-react";
import { directionsUrl, telHref } from "@/content/locations";

const Hours = ({ loc }) =>
  loc.hours ? (
    <ul className="space-y-1 text-sm">
      {loc.hours.map((h) => (
        <li key={h.days} className="flex justify-between gap-4"><span className="opacity-75">{h.days}</span><span className="font-semibold">{h.time}</span></li>
      ))}
    </ul>
  ) : (
    <p className="text-sm opacity-80">{loc.hoursNote}</p>
  );

const Visual = ({ loc }) => (
  <div className="relative h-56 overflow-hidden rounded-[1.6rem]" style={{ background: loc.color }}>
    <motion.img src={loc.image} alt={`TeaDM drink representing ${loc.name}`} className="absolute bottom-[-6%] left-1/2 h-[112%] w-auto -translate-x-1/2 object-contain drop-shadow-[0_25px_25px_rgba(0,0,0,0.35)] transition-transform duration-700 group-hover:-translate-y-3 group-hover:rotate-3" />
    <span className="absolute left-4 top-4 rounded-full bg-[#fff5e8] px-3 py-1 font-display text-xs font-bold uppercase tracking-wider text-[#1a0a10]">{loc.city}</span>
  </div>
);

export const LocationCard = ({ loc, active, onFocus, index }) => (
  <article
    data-testid={`location-card-${loc.slug}`}
    onMouseEnter={onFocus}
    className={`group rounded-[2rem] bg-white p-3 transition-[box-shadow,transform,background-color] duration-500 ${active ? "-translate-y-1 shadow-[0_30px_60px_-30px_rgba(26,10,16,0.55)] ring-2 ring-[#1a0a10]" : "shadow-sm"}`}
  >
    <Visual loc={loc} />
    <div className="p-4 sm:p-5">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="eyebrow opacity-70">{`TeaDM · 0${index + 1}`}</p>
          <h3 className="mt-2 font-display text-3xl font-extrabold leading-none tracking-tight">{loc.name}</h3>
        </div>
        <button type="button" onClick={onFocus} data-testid={`location-show-on-map-${loc.slug}`} className="shrink-0 rounded-full border-2 border-current px-3 py-1.5 text-xs font-bold uppercase tracking-wide">Map</button>
      </div>
      <address className="mt-3 not-italic opacity-90">{loc.street}<br />{loc.city}, {loc.state} {loc.zip}</address>
      <a href={telHref(loc.phone)} data-testid={`location-phone-${loc.slug}`} className="mt-3 inline-flex items-center gap-2 font-semibold hover:underline"><Phone className="h-4 w-4" />{loc.phone}</a>
      <div className="mt-4 flex gap-3"><Clock className="mt-0.5 h-4 w-4 shrink-0 opacity-70" /><div className="flex-1"><Hours loc={loc} /></div></div>
      <p className="mt-4 text-sm opacity-85">{loc.info}</p>
      <div className="mt-6 flex flex-wrap gap-2">
        <a href={loc.orderUrl} target="_blank" rel="noopener noreferrer" data-testid={`location-order-${loc.slug}`} className="btn btn-berry px-5 py-3">Order online <ArrowUpRight className="h-4 w-4" /></a>
        <a href={directionsUrl(loc)} target="_blank" rel="noopener noreferrer" data-testid={`location-directions-${loc.slug}`} className="btn btn-ghost px-5 py-3"><Navigation className="h-4 w-4" />Directions</a>
        <Link to={`/locations/${loc.slug}`} data-testid={`location-details-${loc.slug}`} className="px-2 py-3 text-sm font-bold underline underline-offset-4">Details</Link>
      </div>
    </div>
  </article>
);
